import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { BookAuthor } from "@modules/bookAuthors/types";
import { BookAuthorFormValues } from "@modules/bookAuthors/validations";

import { createBookAuthorService } from "./service";
import { UseCreateBookAuthorMutationOptions } from "./types";

export function useCreateBookAuthorMutation(
  options?: UseCreateBookAuthorMutationOptions
) {
  const { open } = useNotification();

  return useMutation<BookAuthor, ApiError, BookAuthorFormValues>({
    mutationFn: createBookAuthorService,
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
